import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

const validations = {
  form: {
    persons: {
      required
    },
    trip_description: {
      required
    },
    vat: {
      required
    },
    contact: {
      required
    },
    full_name: {
      required
    },
    drop_off_location: {
      required
    },
    pick_up_date: {
      required
    },
    pick_up_location: {
      required
    },
    price: {
      required
    },
    travel_agent_id: {
      required
    }
  }
}

let methods = {
  checkForm () {
    let valid = !this.$v.$invalid
    if (!valid) {
      this.$v.$touch()
    } else {
      this.$v.$reset()
    }
    return valid
  }
}

let computed = {
  ...mapGetters(
    'agents',
    [
      'select2Agents'
    ]
  ),
  ...mapGetters(
    'travelAgents',
    [
      'select2TravelAgents'
    ]
  ),
  ...mapGetters(
    'locations',
    [
      'select2Locations'
    ]
  )
}

const common = {
  methods: {
    ...methods
  },
  computed: {
    ...computed
  }
}

export { common, validations }



// WEBPACK FOOTER //
// ./src/views/bookings/mixins.js